export default __webpack_public_path__ + "static/media/Quetzal.b8607156.jpg";